(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-dynamic-faq"] && !Shopify.designMode) return;
  try {
    
  openCloseNavButton = document.querySelector('.faq-tabs-nav-wrapper .show-faq-tabs-nav-button');
  tabButtons = document.querySelectorAll('.tabular.menu .item');
  answersContents = document.querySelectorAll('.faq-answers-container .faq-category-container');
  buttonMinusIcon = openCloseNavButton.querySelector('.faq-open-close-tabs-nav-button-icon svg.icon-minus');
  buttonPlusIcon = openCloseNavButton.querySelector('.faq-open-close-tabs-nav-button-icon svg.icon-plus');

  tabButtons.forEach(function(tabButton){
    tabButton.addEventListener('click',function(){
      questionBlockHeaderActive = document.querySelector('.faq-answers-container .faq__question.active-question');
      questionBlockContentVisible = document.querySelector('.faq-answers-container .faq__answer-content.visible');
      if (questionBlockHeaderActive && questionBlockContentVisible) {
        questionBlockHeaderActive.classList.toggle('active-question');
        questionBlockContentVisible.classList.toggle('visible');
      }

      contentId = this.dataset.contentId;
      content = document.getElementById(contentId);

      answersContents.forEach(function(content){
          content.classList.add('hidden-content');
      });

      tabButtons.forEach(function(tab){
          tab.classList.remove('active');
      });

      this.classList.add('active');
      content.classList.remove('hidden-content');

      navEl = document.querySelector('.custom-faq .faq-tabs-nav');
      if (window.innerWidth <= 960) {
        openCloseNavButton.querySelector('span').innerHTML = this.dataset.buttonText;
        navEl.classList.remove('show-nav');
        buttonPlusIcon.style.display = "block";
        buttonMinusIcon.style.display = "none";
      }
    });
  });

  openCloseNavButton.addEventListener('click',function(){
    navEl = document.querySelector('.custom-faq .faq-tabs-nav');
    if (navEl.classList.contains('show-nav')) {
      navEl.classList.remove('show-nav');
      buttonPlusIcon.style.display = "block";
      buttonMinusIcon.style.display = "none";
    } else {
      navEl.classList.add('show-nav');
      buttonPlusIcon.style.display = "none";
      buttonMinusIcon.style.display = "block";
    }
  });


  questionBlocksHeaders = document.querySelectorAll('.faq-answers-container .faq__question');
  questionBlocksContents = document.querySelectorAll('.faq-answers-container .faq__answer-content');
  allMinusEl = document.querySelectorAll('.faq-answers-container .faq__question-icon svg.icon-minus');
  allPlusEl = document.querySelectorAll('.faq-answers-container .faq__question-icon svg.icon-plus');

  questionBlocksHeaders.forEach(function(el){
    el.addEventListener('click',function(){
      minusIcon = this.querySelector('.faq__question-icon svg.icon-minus');
      plusIcon = this.querySelector('.faq__question-icon svg.icon-plus');
      answerContent = this.parentElement.querySelector(".faq__answer-content");
      questionBlockHeaderActive = document.querySelector('.faq-answers-container .faq__question.active-question');
      questionBlockContentVisible = document.querySelector('.faq-answers-container .faq__answer-content.visible');
      isActive = this.classList.contains('active-question');


      allMinusEl.forEach(function(el){
          el.style.display = "none";
      });
      allPlusEl.forEach(function(el){
          el.style.display = "flex";
      });
      if (questionBlockHeaderActive && questionBlockContentVisible) {
        questionBlockHeaderActive.classList.toggle('active-question');
        questionBlockContentVisible.classList.toggle('visible');
      }
      if (!isActive) {
        this.classList.toggle('active-question');
        plusIcon.style.display = "none";
        minusIcon.style.display = "flex";
        answerContent.classList.toggle('visible');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-dynamic-tabs"] && !Shopify.designMode) return;
  try {
    
  tabs = document.querySelectorAll('.tab-button');
  tabContents = document.querySelectorAll('.shopify-section .custom__tab-content');

  tabs.forEach(function(tab){
    tab.addEventListener('click',function(){

      contentId = this.dataset.contentId;
      content = document.getElementById(contentId);
      
      tabContents.forEach(function(content){
          content.classList.add('hidden-section');
      });
      
      tabs.forEach(function(tab){
          tab.classList.remove('active');
      });

      this.classList.add('active');
      content.classList.remove('hidden-section');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-site-reviews"] && !Shopify.designMode) return;
  try {
    
  buttons = document.querySelectorAll('.write-review-button');
  siteReviewsFormContainers = document.querySelectorAll('.custom-site-review-form-container');

  buttons.forEach(function(button){
    button.addEventListener('click',function() {
      siteReviewsFormContainers[0].classList.add("visible");
   });
  });

  stars = document.querySelectorAll('.custom-site-review-form-container .star-container svg');
  linearGradients = document.querySelectorAll('.custom-site-review-form-container .star-container svg linearGradient');
  createdAtInput = document.getElementById('custom-site-review-form__review-created-at-date');
  ratingScoreInput = document.getElementById('custom-site-review-form__rating-score');
  ratingScore = 0;

  stars.forEach(function(star){
    star.addEventListener('click',function() {
      ratingScoreInput.value = this.dataset.score;
      ratingScore = Number(this.dataset.score);

      for(let i = 1; i <= 5; i++) {
        color = "#E7721B"
        if (i > Number(this.dataset.score)) {
          color = "#FFFFFF";
        }
        document.querySelectorAll("#" + linearGradients[i - 1].id + " > stop").forEach(function(el) {
          el.setAttribute("stop-color", color);
        })
      }

      const d = new Date();
      const year = d.getFullYear();
      let month = d.getMonth();
      if (month < 10) month = '0' + month;
      let date = d.getDate();
      if (date < 10) date = '0' + date;

      createdAtInput.value = month + '/' + date + '/' + year;
    });
    star.addEventListener('mouseover',function() {
      for(let i = 1; i <= 5; i++) {
        color = "#E7721B"
        if (i > Number(this.dataset.score)) color = "#FFFFFF";
        document.querySelectorAll("#" + linearGradients[i - 1].id + " > stop").forEach(function(el) {
          el.setAttribute("stop-color", color);
        })
      }
    });
    star.addEventListener('mouseout',function() {
      for(let i = 1; i <= 5; i++) {
        color = "#E7721B"
        if (i > ratingScore) color = "#FFFFFF";
        document.querySelectorAll("#" + linearGradients[i - 1].id + " > stop").forEach(function(el) {
          el.setAttribute("stop-color", color);
        })
      }
    });
  });


  window.addEventListener('load', function() {
    siteReviewForm = document.querySelector('.custom-site-review-form-container #contact_form');
    if (siteReviewForm) {
      siteReviewForm.id = "site_review_form";
      siteReviewForm.action = "/contact#site_review_form";
    }

    if (window.location.href.includes("contact_posted=true") === true) {
      tabs = document.querySelectorAll('.tab-button');
      tabs[1].click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-footer"]) return;
  try {
    
  window.addEventListener('load', function() {
    faqLink = document.querySelector('.order-help-link-faq');
    contactUsLink = document.querySelector('.order-help-link-contact_us');
    reviewsLink = document.querySelector('.order-help-link-reviews');
    rewardsLink = document.querySelector('.order-help-link-rewards');
    refundPolicyLink = document.querySelector('.order-help-link-refund_policy');

    accessibilityLink = document.querySelector('.site-link-accessibility');
    privacyPolicyLink = document.querySelector('.site-link-privacy-policy');
    termsConditionsLink = document.querySelector('.site-link-terms-and-conditions');
    termsOfServiceLink = document.querySelector('.site-link-terms-of-service');

    tabs = document.querySelectorAll('.tab-button');
    menuItems = document.querySelectorAll('.tabular .item');
    questionItems = document.querySelectorAll('.faq__question');
    footerCallback = sessionStorage.getItem('footerCallback');

    if (footerCallback) {
      if(footerCallback === 'faqLinkClicked') {
        tabs[2].click();
        menuItems[0].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'contactUsLinkClicked') {
        tabs[1].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'reviewsLinkClicked') {
        tabs[0].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'refundPolicyLinkClicked') {
        tabs[2].click();
        menuItems[0].click();
        questionItems[5].click();
        window.scrollTo(0, 1220);
      } else if (footerCallback === 'accessibilityLinkClicked') {
        tabs[2].click();
        menuItems[6].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'privacyPolicyLinkClicked') {
        tabs[2].click();
        menuItems[5].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'termsConditionsLinkClicked') {
        tabs[2].click();
        menuItems[3].click();
        window.scrollTo(0, 300);
      } else if (footerCallback === 'termsOfServiceLinkClicked') {
        tabs[2].click();
        menuItems[0].click();
        window.scrollTo(0, 300);
      }
      sessionStorage.removeItem('footerCallback');
    }

    faqLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'faqLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[0].click();
      window.scrollTo(0, 300);
    });
    contactUsLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'contactUsLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[1].click();
      window.scrollTo(0, 300);
    });
    reviewsLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'reviewsLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[0].click();
      window.scrollTo(0, 300);
    });
    rewardsLink.addEventListener('click', function(e) {
      if (window.location.href.includes("your-routine") !== true) {
        location.replace("/pages/your-routine");
      }
    });
    refundPolicyLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'refundPolicyLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[0].click();
      questionItems[5].click();
      window.scrollTo(0, 1220);
    });

    accessibilityLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'accessibilityLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[6].click();
      window.scrollTo(0, 300);
    });
    privacyPolicyLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'privacyPolicyLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[5].click();
      window.scrollTo(0, 300);
    });
    termsConditionsLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'termsConditionsLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[3].click();
      window.scrollTo(0, 300);
    });
    termsOfServiceLink.addEventListener('click', function(e) {
      if (window.location.href.includes("find-us") !== true) {
        sessionStorage.setItem('footerCallback', 'termsOfServiceLinkClicked');
        location.replace("/pages/find-us");
      }
      tabs[2].click();
      menuItems[0].click();
      window.scrollTo(0, 300);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
